function splitFlexList(containerSelector, breakSelector) {
  const container = document.querySelector(containerSelector); // The <ul>
  if (!container) return;

  const originalItems = Array.from(container.children); // The original <li> items
  const breakIndex = originalItems.findIndex(item =>
    item.matches(breakSelector),
  );

  if (breakIndex === -1) return;

  // Helper function to safely transform an <li> into a <div>
  function convertLiToDiv(liElement) {
    const div = document.createElement('div');

    // Copy every single attribute (classes, id, etc.) to the new div
    Array.from(liElement.attributes).forEach(attr => {
      div.setAttribute(attr.name, attr.value);
    });

    // Move all inner content (links, text) over
    while (liElement.firstChild) {
      div.appendChild(liElement.firstChild);
    }

    return div;
  }

  // Clear the original <ul> content
  container.innerHTML = '';
  container.classList.add('scroll-wrapper');

  // Create Row 1 as a valid <li> child of the <ul>
  const row1 = document.createElement('li');
  row1.className = 'c-nav__row';

  // Create Row 2 as a valid <li> child of the <ul>
  const row2 = document.createElement('li');
  row2.className = 'c-nav__row';

  // Convert and distribute the items
  originalItems.forEach((item, index) => {
    const transformedDiv = convertLiToDiv(item);

    if (index <= breakIndex) {
      row1.appendChild(transformedDiv); // Goes to row 1
    } else {
      row2.appendChild(transformedDiv); // Goes to row 2
    }
  });

  // Inject the two row <li>s back into the <ul> container
  container.appendChild(row1);
  container.appendChild(row2);
}

// Initialize using your existing classes
splitFlexList('.c-nav__list', '.break');



// WEBPACK FOOTER //
// ./src/scripts/modules/menu-split.js